<template>
  <v-card>
    <!-- <v-card-title class="title card-title-head">
      <v-col cols="12" md="3">
        {{ $i18n.t(label) }}
      </v-col>
      <v-spacer />
    </v-card-title> -->
    <v-simple-table dense>
      <thead>
        <tr style="background-color: rgb(235 244 246)">
          <th class="primary--text">
            {{ $i18n.t("Payment Date") }}
          </th>
          <th class="primary--text">{{ $i18n.t("Payment Mode") }}</th>
          <th class="primary--text">{{ $i18n.t("Amount Paid") }}</th>
          <th class="primary--text">{{ $i18n.t("Settled") }}</th>
          <th class="primary--text">{{ $i18n.t("Status") }}</th>
          <th class="primary--text">{{ $i18n.t("Reference No.") }}</th>
          <th class="text-right primary--text"></th>
        </tr>
      </thead>

      <tbody v-if="payments">
        <tr v-for="(payment, index) in payments" :key="index">
          <td>{{ formatDate(payment.date) }}</td>
          <td>{{ payment.paymentMode }}</td>
          <td>{{ payment.totalAmount }}</td>
          <td>{{ payment.tripUsed }}</td>
          <td>{{ payment.statusStr }}</td>
          <td>{{ payment.refNo }}</td>
          <td>
            <z-confirm-button
              v-show="payment.showDelete"
              class="float-right"
              color="red lighten-1"
              x-small
              fab
              text
              :loading="loading"
              :message="$i18n.t('Do you want to delete this Payment ?')"
              @click="deletePayment(payment._id)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </z-confirm-button>

            <z-payment-done-create
              color="blue"
              style="float: right"
              x-small
              :paymentEdit_id="payment._id"
              :hideBills="true"
              :vendor_id="payment.vendor_id"
              :entity_id="payment.entity_id"
              :trip="trip"
              :singlePage="true"
              btn
              @reload="reload"
            >
              <v-btn color="cyan" text fab x-small>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </z-payment-done-create>
          </td>
        </tr>
      </tbody>
      <tfoot
        v-if="
          billing &&
          billing.fare &&
          billing.fare.pending &&
          billing.fare.pending > 0 &&
          billing.vendor_id
        "
      >
        <tr>
          <td colspan="6" style="text-align: right">
            <z-payment-done-create
              color="blue"
              x-small
              :vendor_id="billing ? billing.vendor_id : null"
              :entity_id="trip.vendorEntity_id"
              :fare="billing ? billing.fare : null"
              :date="dateComputed"
              :trip="trip"
              btn
              :hideBills="true"
              @reload="reload"
            >
              <v-btn color="purple lighten-3" x-small>
                {{ $i18n.t("Add Payment") }}
              </v-btn>
            </z-payment-done-create>
          </td>
        </tr>
      </tfoot>
    </v-simple-table>
  </v-card>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import { Vue, Component } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "SupplierPayment",
  components: {},
  props: {
    trip: {
      default: null,
    },
    billing: {
      default: null,
    },
    hideBills: {
      default: null,
    },
    hideTrips: {
      default: null,
    },
    label: {
      default: "Supplier Payments",
    },
  },
})
export default class SupplierPayment extends Vue {
  dateComputed = null;
  payments = [];

  async fetchPayments() {
    if (this.trip && this.trip._id) {
      const payments = await doGet(
        "/api/paymentmade/trip/" +
          this.trip._id +
          "/payments?vendor_id=" +
          this.billing.vendor_id
      );

      this.payments = payments;
    }
  }

  get loading() {
    return common.loading;
  }

  async deletePayment(paymentmade_id) {
    common.setLoading(true);
    try {
      await doGet("/api/paymentmade/" + paymentmade_id + "/delete");
      common.showMessage("Deleted Successfully");
      this.fetchPayments();
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    await this.fetchPayments();
    this.dateComputed = this.$moment(this.trip.startTime * 1000).format(
      "YYYYMMDD"
    );
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reload(reload) {
    if (reload) {
      this.fetchPayments();
      // this.$root.$emit("event.trip.reload", reload);
      this.$emit("reload", reload);
    }
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
